/** @file Version constants of the editor document schema and the export format. */

export const FORMAT_VERSION = {
  /** Editor document (`pose2d.doc`): integer schema version; migrations run per step. */
  docSchema: 1,
  /** Export format (`pose2d.rig`): semver major.minor; runtimes refuse a different major. */
  rig: '1.0',
  rigMajor: 1,
} as const;
